import {usePullRequestState} from '../../../../hooks/use-pull-request-state'
import {PullRequestState} from '../../../../types'
import {DeleteHeadBranch, shouldShowDeleteHeadBranch} from './DeleteHeadBranch'
import {RestoreHeadBranch} from './RestoreHeadBranch'
import {ReopenPullRequest} from './ReopenPullRequest'
import {useMergeabilityData} from '../mergeability/use-mergeability-data'
import {useLayoutQuery} from '../../../../page-data/loaders/use-layout-query'

export function shouldShowClosedPR(pullRequestState: PullRequestState) {
  return pullRequestState === PullRequestState.Closed
}

export function ClosedPR() {
  const pullRequestState = usePullRequestState()
  const {user} = useLayoutQuery().data
  const mergeabilityData = useMergeabilityData()

  if (!shouldShowClosedPR(pullRequestState)) return null

  const canRestoreHeadRef = Boolean(mergeabilityData?.mergeBoxPullRequest.viewerCanRestoreHeadRef)
  const canReopenPullRequest = Boolean(user?.canReopen && !canRestoreHeadRef)
  const canDeleteHeadBranch = shouldShowDeleteHeadBranch(mergeabilityData)

  return (
    <>
      {canDeleteHeadBranch && <DeleteHeadBranch canReopen={canReopenPullRequest} />}
      {canRestoreHeadRef ? (
        <RestoreHeadBranch />
      ) : !canDeleteHeadBranch ? (
        <ReopenPullRequest canReopen={canReopenPullRequest} />
      ) : null}
    </>
  )
}
